<div class="prefooter-row prefooter-row--loader">
  <ngx-skeleton-loader
    [theme]="{
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: '0',
      left: '0',
      'margin-bottom': '0',
      'background-color': '#dfe1e6',
    }"
  ></ngx-skeleton-loader>
  <div class="prefooter-image-col prefooter-image-col--loader">
    <ngx-skeleton-loader
      [theme]="{
        width: '100%',
        height: '100%',
        margin: '0',
        'background-color': '#f9f9fa',
      }"
    >
    </ngx-skeleton-loader>
  </div>
</div>
